export const API_BASE_URL = process.env.API_BASE_URL;
export const SHOP_URL = 'https://partners.animalpride.com/collections/dfw-lab-rescue-club'